module.exports = __webpack_public_path__ + "static/media/portrait.a47907cc.png";